<div class="custom-dropdown presets-dropdown"
     placement="auto"
     ngbDropdown
     [class.selected]="selectedPresets?.length && (hubAgenciesService.mandatoryPresets?.length || hubAgenciesService.defaultPresets?.length)"
     [class.disabled]="hubAgenciesService.mandatoryPresets?.length">
  <div class="dropdown-toggle" type="button" data-toggle="dropdown" aria-expanded="false" ngbDropdownToggle>
    <span class="material-symbols-outlined">
      tune
    </span>
    <span>
      <ng-container *ngIf="selectedPresets.length">
        <span>{{selectedPresets[0]?.airline}}</span>
        <span class="ml-1">{{selectedPresets[0]?.title}}</span></ng-container>
      <ng-container *ngIf="!selectedPresets.length">{{ 'OFFER_SEARCH.FILTERS.PRESETS.LABEL' | translate }}</ng-container>
    </span>
    <span *ngIf="selectedPresets.length > 1"
          class="counter">
      +{{selectedPresets.length - 1}}
    </span>
  </div>
  <div class="presets-dropdown-menu" ngbDropdownMenu>
    <div class="p-3">
      <div class="checkbox-wrapper">
        <label class="checkbox custom-checkbox-1"
               [for]="'presets-dropdown-all'">
          <input type="checkbox"
                 [id]="'presets-dropdown-all'"
                 [checked]="!selectedPresets?.length"
                 (change)="resetPresets(); allCheckbox.checked = true"
                 #allCheckbox/>
          <div class="checkbox__checkmark"></div>
          <div class="checkbox__body">{{ 'OFFER_SEARCH.FILTERS.PRESETS.NONE' | translate }}</div>
        </label>
      </div>
      <div class="checkbox-wrapper text-nowrap" *ngFor="let preset of hubAgenciesService.presets | filterPresets: owner; last as last">
        <label class="checkbox custom-checkbox-1"
               [for]="'presets-dropdown' + preset.title"
               [class.mb-0]="last">
          <input type="checkbox"
                 [id]="'presets-dropdown' + preset.title"
                 [checked]="selectedPresets.includes(preset)"
                 (change)="selectPreset(preset)"/>
          <div class="checkbox__checkmark"></div>
          <div class="checkbox__body">
            <span class="highlighted-airline">{{ preset.airline }}</span>
            <span class="ml-1">{{ preset.title }}</span>
          </div>
        </label>
        <span class="only-btn" (click)="$event.stopPropagation(); selectOnePreset(preset)">{{ 'OFFER_SEARCH.FILTERS.PRESETS.ONLY' | translate }}</span>
      </div>
    </div>
    <a *ngIf="canEditPresets && editAllowed"
       class="dropdown-item edit-item d-flex align-items-center"
       [routerLink]="['/presets']">
      <span class="material-icons edit-icon">
        edit
      </span>
      <span>{{ 'OFFER_SEARCH.FILTERS.PRESETS.EDIT_PRESETS' | translate }}</span>
    </a>
    <a *ngIf="refreshAllowed"
       class="dropdown-item refresh-item d-flex align-items-center"
       (click)="refreshPresetList()">
      <span class="material-icons refresh-icon" [@rotate]="presetListRefreshToggled">
        refresh
      </span>
      <span>{{ 'OFFER_SEARCH.FILTERS.PRESETS.RELOAD' | translate }}</span>
    </a>
  </div>
</div>
